import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Paint: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_31244)'>
        <path
          d='M1.275 16.4792H11.7253V19.3354L8.65837 22.479C8.55095 22.5891 8.55095 22.7675 8.65837 22.8776C8.7658 22.9877 8.93982 22.9877 9.04724 22.8776L12.0003 19.8507L14.9533 22.8776C15.007 22.9326 15.0774 22.9602 15.1477 22.9602C15.2181 22.9602 15.2885 22.9326 15.3422 22.8776C15.4496 22.7675 15.4496 22.5891 15.3422 22.479L12.2753 19.3354V16.4792H22.725C22.8769 16.4792 23 16.3532 23 16.1974V2.61478C23 2.45898 22.8769 2.33291 22.725 2.33291H12.2753V0.692031C12.2753 0.536229 12.1521 0.410156 12.0003 0.410156C11.8484 0.410156 11.7253 0.536229 11.7253 0.692031V2.33291H1.275C1.12313 2.33291 1 2.45898 1 2.61478V16.1974C1 16.3532 1.12313 16.4792 1.275 16.4792ZM1.55 2.89666H22.45V15.9155H1.55V2.89666Z'
          fill='url(#paint0_linear_12280_31244)'
          stroke='url(#paint1_linear_12280_31244)'
          strokeWidth='0.7'
        />
        <path
          d='M19.431 13.2094H18.7148V8.43075C18.7148 8.33166 18.6639 8.23972 18.5808 8.18879L15.3576 6.21567C15.2728 6.16364 15.1672 6.16227 15.0808 6.21237C14.9948 6.26246 14.9416 6.35606 14.9416 6.45763V13.2094H13.888V6.77859C13.888 6.6795 13.8371 6.58756 13.754 6.53663L10.5308 4.56351C10.446 4.51121 10.3403 4.5101 10.2541 4.5602C10.168 4.6103 10.1148 4.70389 10.1148 4.80547V13.2094H9.0613V9.68928C9.0613 9.59019 9.01041 9.49825 8.9273 9.44732L5.7041 7.4742C5.61924 7.4219 5.51356 7.42079 5.42736 7.47089C5.34128 7.52099 5.28811 7.61458 5.28811 7.71616V13.2094H4.57188C4.42001 13.2094 4.29688 13.3355 4.29688 13.4913C4.29688 13.6471 4.42001 13.7732 4.57188 13.7732H19.431C19.5829 13.7732 19.706 13.6471 19.706 13.4913C19.706 13.3355 19.5829 13.2094 19.431 13.2094ZM15.4916 6.95421L18.1648 8.59069V13.2094H15.4916V6.95421ZM10.6648 5.30205L13.338 6.93852V13.2094H10.6648V5.30205ZM5.83811 8.21274L8.5113 9.84921V13.2094H5.83811V8.21274Z'
          fill='url(#paint2_linear_12280_31244)'
          stroke='url(#paint3_linear_12280_31244)'
          strokeWidth='0.7'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_31244'
          x1='5.55569'
          y1='1.94781'
          x2='15.9836'
          y2='22.3385'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31244'
          x1='5.55569'
          y1='1.94781'
          x2='15.9836'
          y2='22.3385'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_31244'
          x1='7.48775'
          y1='5.15417'
          x2='10.3878'
          y2='14.8371'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_31244'
          x1='7.48775'
          y1='5.15417'
          x2='10.3878'
          y2='14.8371'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_31244'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Paint;
